import React, { useState } from "react";
import { Button, Grid, MenuItem, Skeleton, Tooltip } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import callIcon from "assets/images/callLogo.svg";
import mailIcon from "assets/images/mailLogo.svg";
import locationIcon from "assets/images/locationLogo.svg";
import calender from "assets/images/calender.svg";
import CommonDialog from "components/commonDialog/CommonDialog";
import SuccessDialog from "components/successDialog/SuccessDialog";
import { dateFormate, truncateComment } from "utils/utils";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

function SubHeaderDetails(props) {
  const [edit, setEdit] = useState(false);
  const [successDialog, setSuccessDialog] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const details = props.details;

  const onEditButton = () => {
    setEdit(true);
  };

  const handleClose = () => {
    setEdit(false);
    setSuccessDialog(false);
    setDeleteDialog(false);
  };

  const onDialog = (data, code) => {
    props.onSubmittBtn(data, code);
    setEdit(false);
    setSuccessDialog(false); //should be open for success api
  };

  return (
    <Grid
      item
      container
      direction="column"
      justifyContent="flex-start"
      alignItems="flex-start"
      className="vendorAbout"
      md={props?.type?.toLowerCase() === "driver" ? 12 : 3.3}
      sm={12}
    >
      <Grid
        item
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <h4 className="fontMedium font16">About</h4>
        <div style={{ display: "flex", gap: "15px" }}>
          {props?.editIconFalse ? null : (
            <Button
              sx={{ minWidth: "20px" }}
              variant="contained"
              className="vendorEditBtn"
              onClick={() => {
                onEditButton();
              }}
            >
              <span>
                <EditOutlinedIcon />
              </span>
            </Button>
          )}
          {props?.type?.toLowerCase() === "driver" && (
            <div className="deleteIconFix">
              <Button
                sx={{ minWidth: "20px" }}
                variant="contained"
                className="DriverandvehicledeleteBtn"
                onClick={() => {
                  setDeleteDialog(true);
                }}
              >
                <span>
                  <DeleteOutlineIcon />
                </span>
              </Button>
            </div>
          )}
        </div>
      </Grid>
      <Grid item direction="row" just>
        {props?.loader ? (
          <Skeleton animation="wave" width={200} height={50} />
        ) : (
          <MenuItem className="iconAlign ">
            <img src={mailIcon} alt="mail icon" />

            {/* <p className="font14  marginInline textWrap">{details?.email ? details?.email : 'Not Available'}</p> */}
            <Tooltip
              title={details?.email}
              placement="bottom"
              className="font14 marginInline"
            >
              <span
                className="font14 marginInline textWrap"
                style={{
                  wordBreak: "break-word",
                  overflowWrap: "anywhere",
                  maxWidth: "180px", // keeps inside About card
                  display: "inline-block",
                }}
              >
                {truncateComment(details?.email, 25)}
              </span>
            </Tooltip>
          </MenuItem>
        )}

        {props?.loader ? (
          <Skeleton animation="wave" width={200} height={50} />
        ) : (
          <MenuItem className="iconAlign subHeaderCard">
            <img src={callIcon} alt="callIcon" />

            <p className="  font14 marginInline textWrap">
              {details?.mobile ? details?.mobile : "Not Available"}
            </p>
          </MenuItem>
        )}
        {props?.loader ? (
          <Skeleton animation="wave" width={200} height={50} />
        ) : (
          <MenuItem className="iconAlign subHeaderCard">
            <img src={locationIcon} alt="location" />

            <p className=" font14  marginInline textWrap">
              {details?.location
                ? details?.location
                : details?.city
                ? details?.city
                : "Not Available"}
            </p>
          </MenuItem>
        )}
        {props?.loader ? (
          <Skeleton animation="wave" width={200} height={50} />
        ) : (
          <MenuItem className="iconAlign subHeaderCard">
            <img src={calender} alt="location" />

            <p className=" font14  marginInline">
              {details?.createdAt
                ? dateFormate(details?.createdAt, "DD MMMM YYYY")
                : "Not Available"}
            </p>
          </MenuItem>
        )}

        {edit && (
          <CommonDialog
            open={edit}
            handleClose={handleClose}
            formData={props?.editData}
            button={"dialogButton"}
            onSubmittBtn={onDialog}
            type={"Edit " + props?.type + " "}
            selectType={"edit"}
            details={details}
          />
        )}
        {deleteDialog && (
          <CommonDialog
            open={deleteDialog}
            handleClose={handleClose}
            selectType="delete"
            typeOfDialog={`${props?.type}`}
            text="Are you sure you want to delete this Driver? This cannot be undone."
            onConfirmDialog={() => {
              props.onDelete?.(); // trigger delete from parent
              setDeleteDialog(false);
            }}
          />
        )}
        {successDialog && (
          <SuccessDialog
            open={successDialog}
            handleClose={handleClose}
            type={"Edit " + props?.type}
          />
        )}
      </Grid>
    </Grid>
  );
}

export default SubHeaderDetails;
